export default __webpack_public_path__ + "static/media/numero_vert.d3a93697.png";